// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1ccK1","errorLogs":"EditorFooter_errorLogs__2sFs4"};